var UserData = React.createContext({});
export var UserDataProvider = UserData.Provider;
export var UserDataConsumer = UserData.Consumer;
export default UserData;